var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00409 7.98463C4.87249 7.98553 4.74202 7.95588 4.62019 7.89741C4.49835 7.83894 4.38753 7.75278 4.29409 7.64387L0.294092 2.94378C0.200853 2.83423 0.126893 2.70416 0.0764322 2.56102C0.0259719 2.41788 1.96485e-09 2.26446 0 2.10952C-1.96485e-09 1.95458 0.0259719 1.80116 0.0764322 1.65802C0.126893 1.51487 0.200853 1.38481 0.294092 1.27525C0.38733 1.16569 0.498021 1.07879 0.619843 1.0195C0.741665 0.960204 0.872233 0.929687 1.00409 0.929688C1.13595 0.929688 1.26652 0.960204 1.38834 1.0195C1.51016 1.07879 1.62085 1.16569 1.71409 1.27525L5.00409 5.16458L8.30409 1.428C8.39608 1.30781 8.50819 1.21121 8.6334 1.14425C8.75862 1.07729 8.89424 1.04141 9.03179 1.03885C9.16935 1.03629 9.30587 1.06711 9.43283 1.12937C9.55978 1.19164 9.67444 1.28401 9.76962 1.40072C9.86481 1.51743 9.93848 1.65596 9.98602 1.80765C10.0336 1.95934 10.054 2.12092 10.0459 2.2823C10.0379 2.44367 10.0016 2.60136 9.93936 2.74551C9.8771 2.88965 9.7902 3.01715 9.68409 3.12004L5.68409 7.65563C5.50122 7.8628 5.25809 7.98043 5.00409 7.98463Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCaret);
export default __webpack_public_path__ + "static/media/downCaret.6145629384e4f399a8e452343d5a6f2b.svg";
export { ForwardRef as ReactComponent };